import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18nextConf';
import initPopupScrollLock from './utils/popupScrollLock';

const rootElement = document.getElementById('root');
const appBasename = '/app';
const currentPath = window.location.pathname;
const isAppPath = currentPath === appBasename || currentPath.startsWith(`${appBasename}/`);
const appHashNormalizationPaths = new Set([
  appBasename,
  `${appBasename}/`,
  `${appBasename}/en`,
  `${appBasename}/en/`,
  `${appBasename}/fr`,
  `${appBasename}/fr/`,
  `${appBasename}/fr-CA`,
  `${appBasename}/fr-CA/`,
  `${appBasename}/en-US`,
  `${appBasename}/en-US/`,
]);
const shouldNormalizeHashedReload = appHashNormalizationPaths.has(currentPath);

if (isAppPath && window.location.hash && shouldNormalizeHashedReload) {
  try {
    const navigationEntry = performance.getEntriesByType?.('navigation')?.[0];
    const isReloadNavigation = navigationEntry?.type === 'reload';
    const currentHashPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const lastIntentionalHashPath = sessionStorage.getItem('lastIntentionalHashPath');

    if (isReloadNavigation && lastIntentionalHashPath === currentHashPath) {
      window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.search}`);
    }
  } catch (storageError) {
    console.warn('Unable to normalize hashed reload path:', storageError);
  }
}

if (!isAppPath) {
  const normalizedLandingPath = (() => {
    if (currentPath === '/' || currentPath === '/en' || currentPath === '/en/index.html') {
      return '/en/';
    }
    if (currentPath === '/fr' || currentPath === '/fr/index.html') {
      return '/fr/';
    }
    return null;
  })();

  if (normalizedLandingPath && normalizedLandingPath !== currentPath) {
    window.location.replace(normalizedLandingPath);
  }
}

const AppToRender = (
  <React.StrictMode>
    <Router basename={appBasename} future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <Suspense fallback={null}>
        <App />
      </Suspense>
    </Router>
  </React.StrictMode>
);

if (isAppPath) {
  ReactDOM.render(AppToRender, rootElement);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Initialize popup scroll lock to prevent background scrolling when popups are open
// Popup scroll-lock disabled temporarily. The MutationObserver-based implementation
// was causing the app to become unresponsive in some cases (blocking interactions).
// We'll replace this with a safer programmatic API or re-enable after fixes.
// initPopupScrollLock();
